import React, { useEffect } from "react";
import {
  useTweaks, TweaksPanel, TweakSection, TweakRadio,
  TweakToggle, TweakColor, TweakText,
} from "./tweaks-panel.jsx";

/* ============================================================
   Talention — Tweaks (lean: just accent + density + glass)
   ============================================================ */

const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
  "accent": "#1d1d1f",
  "density": "comfy",
  "ambient": true,
  "brandGlyph": "T"
}/*EDITMODE-END*/;

function Tweaks() {
  const [t, setTweak] = useTweaks(TWEAK_DEFAULTS);

  useEffect(() => {
    const root = document.documentElement;
    // accent
    root.style.setProperty("--brand-500", t.accent);
    root.style.setProperty("--brand-600", shade(t.accent, -12));
    root.style.setProperty("--brand-400", shade(t.accent, 12));
    root.style.setProperty("--brand-300", shade(t.accent, 26));
    root.style.setProperty("--brand-50",  shade(t.accent, 88));
    root.style.setProperty("--brand-100", shade(t.accent, 76));
    root.style.setProperty("--brand-700", shade(t.accent, -22));

    // density
    if (t.density === "compact") {
      root.style.setProperty("--card-pad", "16px");
    } else if (t.density === "spacious") {
      root.style.setProperty("--card-pad", "28px");
    } else {
      root.style.setProperty("--card-pad", "22px");
    }

    // ambient
    const amb = document.querySelector(".ambient");
    if (amb) amb.style.display = t.ambient ? "" : "none";

    // brand glyph
    const brand = document.querySelector(".brand-mark");
    if (brand) brand.textContent = t.brandGlyph;
  }, [t]);

  return (
    <TweaksPanel title="Tweaks">
      <TweakSection label="Identidad" />
      <TweakColor
        label="Color de acento"
        value={t.accent}
        options={["#1d1d1f", "#0a84ff", "#34c759", "#af52de", "#ff3b30", "#ec7a15"]}
        onChange={(v) => setTweak("accent", v)}
      />
      <TweakText
        label="Iniciales de marca"
        value={t.brandGlyph}
        onChange={(v) => setTweak("brandGlyph", v.slice(0, 2))}
      />

      <TweakSection label="Diseño" />
      <TweakRadio
        label="Densidad"
        value={t.density}
        options={["compact", "comfy", "spacious"]}
        onChange={(v) => setTweak("density", v)}
      />
      <TweakToggle
        label="Decoración ambiente"
        value={t.ambient}
        onChange={(v) => setTweak("ambient", v)}
      />
    </TweaksPanel>
  );
}

function shade(hex, percent) {
  const h = hex.replace("#", "");
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  const adj = (c) => {
    if (percent >= 0) return Math.round(c + (255 - c) * (percent / 100));
    return Math.round(c * (1 + percent / 100));
  };
  const toHex = (n) => Math.max(0, Math.min(255, n)).toString(16).padStart(2, "0");
  return "#" + toHex(adj(r)) + toHex(adj(g)) + toHex(adj(b));
}

export { Tweaks };